// extracted by mini-css-extract-plugin
module.exports = {"link":"NewTabLink_link__3m4jn","newTab":"NewTabLink_newTab__3GXAq","status":"NewTabLink_status__2A0cz"};